var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileVerfifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0365 0H6.97548C2.6053 0 0 2.7125 0 7.2625V17.725C0 22.2875 2.6053 25 6.97548 25H17.0245C21.3947 25 24 22.2875 24 17.7375V7.2625C24.012 2.7125 21.4067 0 17.0365 0ZM17.7448 9.625L10.9374 16.7125C10.7694 16.8875 10.5413 16.9875 10.3011 16.9875C10.061 16.9875 9.8329 16.8875 9.66482 16.7125L6.26712 13.175C5.91895 12.8125 5.91895 12.2125 6.26712 11.85C6.6153 11.4875 7.19158 11.4875 7.53976 11.85L10.3011 14.725L16.4722 8.3C16.8204 7.9375 17.3967 7.9375 17.7448 8.3C18.093 8.6625 18.093 9.25 17.7448 9.625Z",
    fill: "#C1F700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileVerfifiedIcon);
export default __webpack_public_path__ + "static/media/profile-verfified-icon.c18dbf7091141c5637aece6ecbd521af.svg";
export { ForwardRef as ReactComponent };